import { Checkbox, type CheckboxColor } from '@scaleaq/scaleui';
import { Control, Controller, FieldValues, Path, RegisterOptions } from 'react-hook-form';

type ControlledCheckboxProps<T extends FieldValues> = {
  control: Control<T>;
  color?: CheckboxColor;
  disabled?: boolean;
  label: string;
  name: Path<T>;
  render?: boolean;
  rules?: Omit<
    RegisterOptions<T, Path<T>>,
    'valueAsNumber' | 'valueAsDate' | 'setValueAs' | 'disabled'
  >;
};

export const ControlledCheckbox = <T extends FieldValues>({
  control,
  color = 'action',
  disabled,
  label,
  name,
  render = true,
  rules,
}: ControlledCheckboxProps<T>) => {
  if (!render) return;

  return (
    <Controller
      control={control}
      name={name}
      rules={rules}
      render={({ field }) => (
        <Checkbox
          id={name}
          checked={!!field.value}
          color={color}
          disabled={disabled}
          label={label}
          onChange={field.onChange}
        />
      )}
    />
  );
};
